import { useTranslation } from 'react-i18next';

export default function Accessories() {
  const { t } = useTranslation();

  return (
    <section id="accessories" className="py-20 bg-gradient-to-b from-white via-pink-50/30 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t('accessories.title')} <span className="bg-gradient-to-r from-pink-500 to-amber-400 bg-clip-text text-transparent">{t('accessories.titleHighlight')}</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            {t('accessories.subtitle')}
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-gradient-to-br from-pink-50 to-amber-50/30 rounded-3xl p-12 md:p-16 text-center border-2 border-pink-200 shadow-xl">
            <div className="mb-6">
              <i className="ri-time-line text-6xl text-pink-500 w-16 h-16 flex items-center justify-center mx-auto"></i>
            </div>
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              {t('accessories.comingSoon')}
            </h3>
            <p className="text-lg text-gray-600 mb-8 max-w-xl mx-auto">
              {t('accessories.comingSoonDescription')}
            </p>
            <div className="flex flex-wrap gap-4 justify-center">
              <div className="bg-white px-6 py-3 rounded-full shadow-md">
                <span className="text-pink-600 font-semibold">{t('accessories.categories.collars')}</span>
              </div>
              <div className="bg-white px-6 py-3 rounded-full shadow-md">
                <span className="text-pink-600 font-semibold">{t('accessories.categories.beds')}</span>
              </div>
              <div className="bg-white px-6 py-3 rounded-full shadow-md">
                <span className="text-pink-600 font-semibold">{t('accessories.categories.toys')}</span>
              </div>
              <div className="bg-white px-6 py-3 rounded-full shadow-md">
                <span className="text-pink-600 font-semibold">{t('accessories.categories.carriers')}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 bg-gradient-to-r from-pink-500 to-amber-400 rounded-3xl p-8 md:p-12 text-center text-white shadow-2xl">
          <i className="ri-notification-line text-5xl mb-4 w-12 h-12 flex items-center justify-center mx-auto"></i>
          <h3 className="text-3xl font-bold mb-4">{t('accessories.notifyMe.title')}</h3>
          <p className="text-xl mb-6 max-w-2xl mx-auto opacity-95">
            {t('accessories.notifyMe.description')}
          </p>
          <button className="bg-white text-pink-600 px-8 py-4 rounded-full text-lg font-semibold hover:bg-pink-50 transition-all shadow-xl cursor-pointer whitespace-nowrap">
            {t('accessories.notifyMe.button')}
          </button>
        </div>
      </div>
    </section>
  );
}
